import moment from "moment";
import { TokenClientes } from "../../interfaces/entities/TokenClientes";
import { postRefreshToken } from "../../services/LoginService";

export const setTokenClientes = (tokenClientes: TokenClientes): void => {
  sessionStorage.setItem('tokenClientes', JSON.stringify(tokenClientes));
}

export const getTokenClientes = async (): Promise<string | null> => {
  const tokenClientes = sessionStorage.getItem('tokenClientes');
  if (tokenClientes) {
    let objTokenClients: TokenClientes = JSON.parse(tokenClientes);
    var dtExpirada = moment(objTokenClients.dados.expiresIn).isSameOrBefore(moment());
    if (dtExpirada) {
      return await reauth();
    } else {
      return objTokenClients.dados.accessToken;
    }
  }
  return null
}


const reauth = async (): Promise<string | null> => {
  const tokenClientes = sessionStorage.getItem('tokenClientes');
  if (tokenClientes) {
    let objTokenClients: TokenClientes = JSON.parse(tokenClientes);
    var dtExpirada = moment(objTokenClients.dados.expiresIn).isSameOrBefore(moment());
    if (dtExpirada) {
      var response = await postRefreshToken(objTokenClients.dados.accessToken, objTokenClients.dados.refreshToken)
      if (response?.status === 200) {
        setTokenClientes(response.data);
        return response.data.dados.accessToken;
      } else {
        sessionStorage.clear();
        window.location.reload();
      }
    } else {
      return objTokenClients.dados.accessToken;
    }
  }
  return null
}